export const environment = {
  production: true,
  hmr: false,
  defaultBrokenUserImage: "../assets/images/logo/logo-icon.png",
  apiPath: "/api",
  imagesPath: "/wwwroot",


  // ======= BETA CONFIG =======
  serverUrl: "https://api-beta-v2.etailsupport.com",
  apiUrl: "https://api-beta-v2.etailsupport.com/api",
  fileBaseUrl: "https://beta.etailsupport.com/",
  customerFrontendUrl: "https://customer-beta.etailsupport.com",
  cleverDealsUrl: "https://beta.cleverdeals.net",
  v1Url: "https://beta.etailsupport.com",
};
